import React, { useState } from "react";
import { Trash2, AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const DeleteAccount = () => {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");

  const validateEmail = (email) => {
    if (!email || email.trim() === "") {
      return "Email is required.";
    }

    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!re.test(String(email).toLowerCase())) {
      return t("pleaseEnterValidEmail");
    }

    return "";
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationError = validateEmail(email);

    if (validationError) {
      setError(validationError);
      return;
    }

    setError("");

    setIsSubmitted(true);
    setEmail("");
  };

  return (
    <div className="bg-orange-50 flex items-center justify-center p-4 font-sans">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-sm border border-orange-100 overflow-hidden">
        <div className="p-8">
          <div className="flex justify-center mb-4">
            <div className="bg-red-50 p-3 rounded-full">
              <Trash2 className="text-red-500" size={32} />
            </div>
          </div>

          <h2 className="text-2xl font-bold text-gray-800 text-center mb-2">
            {t("deleteAccount")}
          </h2>
          <p className="text-gray-500 text-center mb-8 text-sm">
            {t("deleteAcoountDescription")}
          </p>

          {!isSubmitted ? (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {t("email")}
                </label>
                <input
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition-all"
                  placeholder="Enter your email"
                />
                {error && (
                  <p className="mt-2 text-xs text-red-500 flex items-center gap-1">
                    <AlertCircle size={12} /> {error}
                  </p>
                )}
              </div>

              <button
                type="submit"
                className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 rounded-lg transition-colors shadow-md shadow-orange-200"
              >
                {t("deleteMyAccount")}
              </button>
            </form>
          ) : (
            <div className="bg-green-50 border border-green-100 rounded-xl p-4 animate-fade-in">
              <p className="text-green-700 text-sm text-center font-medium">
                {t("weHaveReceivedYourRequest")}
              </p>
              <button
                onClick={() => setIsSubmitted(false)}
                className="mt-4 w-full text-xs text-green-600 hover:underline"
              >
                {t("goBack")}{" "}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteAccount;
